import { gql } from "@apollo/client"
import { BACKGROUND_CHECK_ORDER_FRAGMENT } from "../../utils/prospect/withProspectQuery"

export const REINSTATEMENT_STEPS_QUERY = gql`
  query ReinstatementSteps {
    currentMember {
      prospect {
        backgroundCheck {
          status
          screenedAt
          expiredAt
        }
        backgroundCheckOrder {
          ${BACKGROUND_CHECK_ORDER_FRAGMENT}
          createdAt
        }
      }
    }
  }
`
